export default "__VITE_ASSET__CaUK_t_K__"